import { parseISO, addMinutes, addSeconds, format } from 'date-fns';
import { ISeat, IRacket } from '@/pages/Cart/types';
import { ITotalCartItems } from '@/redux/cart/types';
import { fetchCreateCancelRent } from '@/redux/rent/asyncActions';
import { getPartnerIdFromStorage } from '@/utils/storage/partnerId';
import store from '@/redux/store';

type AppDispatch = typeof store.dispatch;

export async function checkExpiredCourtItems(
  courtRent: { [key: string]: ISeat },
  dispatch: AppDispatch
): Promise<{ [key: string]: ISeat }> {
  const now = new Date();
  const expiredItems: Array<{ courtId: string; startTime: string; finishTime: string }> = [];
  const validItems: { [key: string]: ISeat } = {};

  Object.keys(courtRent).forEach((key) => {
    const seat = courtRent[key] as ISeat;
    const startTimeISO = seat.startTimeCourt || `${seat.date}T${seat.time}:00`;
    const startTime = parseISO(startTimeISO);
    
    const timeLimit = 11 * 60 * 1000;
    const timeDifference = now.getTime() - startTime.getTime();

    if (timeDifference >= timeLimit) {
      const finishTime = addSeconds(addMinutes(startTime, 59), 59);
      
      expiredItems.push({
        courtId: seat.courtId?.toString() || '',
        startTime: startTime.toISOString(),
        finishTime: finishTime.toISOString(),
      });
    } else {
      validItems[key] = seat;
    }
  });

  if (expiredItems.length > 0) {
    const partnerId = getPartnerIdFromStorage();
    
    if (partnerId) {
      try {
        const cancelBasket: { [key: string]: any } = {};
        expiredItems.forEach((item, index) => {
          const expiredKey = Object.keys(courtRent).find(
            (key) => {
              const seat = courtRent[key] as ISeat;
              const startTimeISO = seat.startTimeCourt || `${seat.date}T${seat.time}:00`;
              return parseISO(startTimeISO).toISOString() === item.startTime;
            }
          );
          
          if (expiredKey) {
            cancelBasket[expiredKey] = courtRent[expiredKey];
          }
        });

        await dispatch(
          fetchCreateCancelRent({
            newBasket: {},
            cancelBasket: cancelBasket as any,
            partnerId,
          })
        ).unwrap();
      } catch (error) {
        console.error('Ошибка отмены истекших кортов:', error);
      }
    }
  }

  return validItems;
}

export function checkExpiredRacketItems(
  racketRent: { [key: string]: IRacket }
): { [key: string]: IRacket } {
  const now = new Date();
  const validItems: { [key: string]: IRacket } = {};

  Object.keys(racketRent).forEach((key) => {
    const racket = racketRent[key] as IRacket;
    const startTimeISO = racket.startTimeRacket || `${racket.date}T${racket.time}:00`;
    const startTime = parseISO(startTimeISO);
    
    const timeLimit = 15 * 60 * 1000;
    const timeDifference = now.getTime() - startTime.getTime();

    if (timeDifference < timeLimit) {
      validItems[key] = racket;
    }
  });

  return validItems;
}

export function sortCourts(courtRent: { [key: string]: ISeat }): ISeat[] {
  const courtsArray = Object.values(courtRent) as ISeat[];

  return courtsArray.sort((a, b) => {
    const dateA = a.date || '';
    const dateB = b.date || '';
    const dateCompare = dateA.localeCompare(dateB);
    if (dateCompare !== 0) return dateCompare;

    const courtIdA = a.courtId || 0;
    const courtIdB = b.courtId || 0;
    const courtIdCompare = courtIdA - courtIdB;
    if (courtIdCompare !== 0) return courtIdCompare;

    const startTimeA = a.startTimeCourt || `${a.date}T${a.time}:00`;
    const startTimeB = b.startTimeCourt || `${b.date}T${b.time}:00`;
    return startTimeA.localeCompare(startTimeB);
  });
}
